import { tsv } from "@faire/slate/lib/tsv";
import { Link as LinkAnchor } from "@faire/web/ui/LinkAnchor";
import React from "react";

interface IInternalProps<E extends React.ElementType> {
  /**
   * The component to render the link as. By default, it renders as Link from @faire/web/ui/LinkAnchor.
   */
  as?: E;
}

type IProps<E extends React.ElementType> = IInternalProps<E> &
  Omit<React.ComponentProps<E>, keyof IInternalProps<E>>;

/**
 * Component with basic link styling.
 * This component is intended to be used in context of other components that have text styles.
 *
 * **!!!important!!!** The underlying component should not be a button.
 * Browsers render buttons such that they cannot be inlined in paragraphs.
 */
export const Link = <E extends React.ElementType = typeof LinkAnchor>(
  props: IProps<E>
) => {
  const { as: Component = LinkAnchor, className, ...rest } = props;
  const linkCls = linkStyle.cls({ className });

  return <Component {...rest} className={linkCls} />;
};

const linkStyle = tsv({
  base: [
    "focusable interactive",
    "inline underline underline-offset-[0.25em]",
    "text-inherit",
  ],
});
